import { css as a } from "@microsoft/fast-element";
import { normalize as i } from "../common/normalize.js";
import { display as n, PropertyStyleSheetBehavior as l } from "@matrix42/fast-foundation";
import { typography as o } from "../styles/typography.js";
import { designTokens as r } from "../design-tokens.js";
function c(t, e) {
  return new l("actionable", t, e);
}
const p = a`
  .rating-star {
    cursor: pointer;
  }

  .rating-star:active {
    color: ${r.color.warning[60]};
  }
`, h = a`
  ${i}
  ${n("flex")}
  .control {
    display: flex;
    gap: calc(0.438 * ${r.spacing[4]});
    user-select: none;

    align-items: center;

    /* Typography */
    ${o("p", "regular")}
  }

  .rating-stars {
    display: flex;
    gap: ${r.spacing["0.5"]};
    color: ${r.color.neutral[50]};
  }

  .hidden {
    display: none;
  }

  .rating-star-active {
    color: ${r.color.warning[80]};
  }

  .rating-info {
    width: calc(1.313 * ${r.spacing[4]});
    color: ${r.color.neutral[80]};
    /* Typography */
    ${o("label", "regular")}
  }

  .rating-value {
    color: ${r.color.neutral[300]};
    /* Typography */
    ${o("p", "semibold")}
  }
`.withBehaviors(c(!0, p));
export {
  h as ratingStyles
};
